import { render } from "./YouryEmail.vue?vue&type=template&id=3850b09a&scoped=true"
import script from "./YouryEmail.vue?vue&type=script&lang=js"
export * from "./YouryEmail.vue?vue&type=script&lang=js"

import "./YouryEmail.vue?vue&type=style&index=0&id=3850b09a&scoped=true&lang=css"
import "./YouryEmail.vue?vue&type=style&index=1&id=3850b09a&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/youry.co/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3850b09a"]])

export default __exports__